import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@repo/shared-styles";
import {staticUrl} from "@repo/urls";

class SponsorLogo extends React.Component<{
    imgAltText: string;
    imgHeight: number;
    imgPath: string;
}> {
    render(): React.ReactNode {
        const {imgAltText, imgHeight, imgPath} = this.props;

        return (
            <div className={css(styles.sponsor)}>
                <img
                    alt={imgAltText}
                    className={css(styles.img)}
                    height={imgHeight}
                    src={staticUrl(imgPath)}
                />
            </div>
        );
    }
}

export default class SponsorsArea extends React.Component<Record<any, any>> {
    render(): React.ReactNode {
        return (
            <div className={css(styles.container)}>
                <div className={css(styles.logoContainer)}>
                    <SponsorLogo
                        imgAltText={t`super simple logo`}
                        imgHeight={45}
                        imgPath="/images/kids/ss-logo-bw@3x.png"
                    />

                    <SponsorLogo
                        imgAltText={t`nhsa logo`}
                        imgHeight={45}
                        imgPath="/images/kids/all-white-logo-1@3x.png"
                    />

                    <SponsorLogo
                        imgAltText={t`bellweather media logo`}
                        imgHeight={73}
                        imgPath="/images/kids/centered-bw-logo-white@3x.png"
                    />

                    <SponsorLogo
                        imgAltText={t`young explorer logo`}
                        imgHeight={63}
                        imgPath="/images/kids/young-explorer-logo-all-white@3x.png"
                    />
                </div>
                <hr className={css(styles.areaDivider)} />
            </div>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: color.darkBlue,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },

    logoContainer: {
        display: "flex",
        justifyContent: "center",
        padding: "40px 0 20px",

        [mediaQueries.smOrSmaller]: {
            padding: "20px 0 10px",
        },
    },

    sponsor: {
        padding: "0 40px",

        [mediaQueries.md]: {
            padding: "0 20px",
        },

        [mediaQueries.smOrSmaller]: {
            padding: "0 10px",
        },
    },

    img: {
        height: 50,

        [mediaQueries.md]: {
            height: 38,
        },

        [mediaQueries.smOrSmaller]: {
            height: 27,
        },
    },

    areaDivider: {
        width: "86%",
    },
});
